// extracted by mini-css-extract-plugin
var _1 = "TasksWidgetItem-moduleTasksWidgetItem__N9yO5 ListItem-moduleListItem__NInUA";
var _2 = "TasksWidgetItem-modulecontentContainer__EoFIj ListItemContentContainer-moduleListItemContentContainer__LR78T";
var _3 = "TasksWidgetItem-modulehover__AKnY1";
export { _1 as "TasksWidgetItem", _2 as "contentContainer", _3 as "hover" }
